var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.page_loaded)?_c('app-spinner'):[_c('app-cells',[_c('h1',{staticClass:"title"},[_vm._v("Legal entities")])]),_c('table-legal-entities',{attrs:{"table-items":_vm.table_items}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }